export default __webpack_public_path__ + "static/media/ExpireError.468b0627.mp3";